<script setup lang="ts">
interface Question {
	question: string
	answer: string
}

interface Section {
	name: string
	questions: Question[]
}

const questions: Section[] = [
	{
		name: 'General Questions',
		questions: [
			{
				question: 'How can I switch between subscriptions?',
				answer: 'Right now we are in a beta phase, if you want to switch between subscriptions, please contact us.',
			},
			{
				question: 'How can I cancel my subscription?',
				answer: 'You can cancel your subscription at any time by contacting us.',
			},
			{
				question: 'How can I change my billing information?',
				answer: 'You can change your billing information by contacting us.',
			},
			{
				question: 'How can I change my account information?',
				answer: 'You can change your account information on the account page.',
			},
			{
				question: 'How are my team colors determined?',
				answer: 'The team colors are determined by the primary colors of your store and updated once a month.',
			},
			{
				question: 'In which timezone are the dates and times displayed?',
				answer: 'You can change your preferred timezone on the account page.',
			},
			{
				question: 'I am missing a feature, what should I do?',
				answer: 'We are constantly working on improving our platform and adding new features. If you are missing a feature, please contact us and we will do our best to implement it.',
			},
		],
	},
	{
		name: 'Data Collection',
		questions: [
			{
				question: 'Data from my store is not showing up, what should I do?',
				answer: 'We are extracting data from your store using the following IP address: 49.12.184.91, please make sure that this IP address is not blocked by your firewall. Please note that this IP address is not used for competitors data extraction. If you are still experiencing issues, please contact us. Be aware that we can add multiple new IP addresses in the near future.',
			},
			{
				question: 'Data from my store is not refreshed, what should I do?',
				answer: 'Please make sure you have at least one competitor added to your product. We are refreshing data only if you have at least one competitor added to your product. If you are still experiencing issues, please contact us.',
			},
			{
				question: 'Data from my store or competitors is not showing up, what should I do?',
				answer: 'We make use of an advanced data extraction algorithm which covers the biggest portion of e-commerce solutions, but sometimes it may not work as expected. We do offer custom made data extraction solutions, please contact us for more information.',
			},
			{
				question: 'My product images are not showing up, what should I do?',
				answer: 'Please make sure that your product images are publicly accessible and hotlinking is allowed. If you are still experiencing issues, please contact us.',
			},
			{
				question: 'How often is the data updated?',
				answer: 'This depends on your subscription plan. We offer data updates every week or twice a week. If you need more frequent updates, please contact us.',
			},
			{
				question: 'How long will it take for the first data to show up?',
				answer: 'It usually takes 24 hours for the first data to show up. If you are still experiencing issues, please contact us.',
			},
			{
				question: 'How many competitors can I track?',
				answer: 'This depends on your subscription plan. You can check the usage page to see your current limits and usage.',
			},
			{
				question: 'Can you tell more about your data extraction algorithm?',
				answer: 'It is mix between custom made algorithms and AI which we are constantly improving. But like a chef, we can not reveal all our secrets.',
			},
		],
	},
]
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper class="flex flex-col gap-8">
		<template v-for="section in questions" :key="section.name">
			<div>
				<h2 class="text-primary mb-4 rounded border-b py-2 text-2xl font-bold">
					{{ section.name }}
				</h2>

				<div class="flex flex-col gap-6">
					<faq-question
						v-for="question in section.questions"
						:key="question.question"
						:question="question.question"
						:answer="question.answer"
						class="max-w-3xl"
					/>
				</div>
			</div>
		</template>
	</content-wrapper>
</template>
